module.exports = __webpack_public_path__ + "img/四川天府新区红樱美幼儿园.16c68693.jpg";